export default __webpack_public_path__ + "static/laptop-0d8e042f634d82011cfd339d9b629584.png";